const $ = jQuery;

class InteractiveImage {
    constructor() {
        this.activeClass = 'interactive-image__popup--open';
    }
	init() {
        $( '.interactive-image__popup-trigger' ).on( 'click', this.openPopup.bind(this) );
        $( '.interactive-image__close' ).on( 'click', this.closePopup.bind(this) );
    }

	openPopup(e) { 
		const popup = $( e.currentTarget ).next('.interactive-image__popup');

        const containerHeight = popup.outerHeight() + 60;
        popup.parents('.interactive-image')
            .css( 'min-height', containerHeight );

        popup.attr('aria-hidden', false).addClass( this.activeClass );

	}

    closePopup(e) {
        $( e.currentTarget )
            .parents('.interactive-image')
            .css( 'min-height', '0' )
            .find('.interactive-image__popup')
                .attr('aria-hidden', true)
                .removeClass( this.activeClass );
    }
}

export default new InteractiveImage;